// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__GMTcB","active":"style_active__REkQf","selected":"style_selected__K+P4p","btn":"style_btn__yoMIK","dot-container":"style_dot-container__wgyah"};